import Axios from 'axios'
import store from '../store'
import strings from '@/strings.js'

const invite = {
  getDesk4meUrl(){ 
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getInvites() {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/invites`)
  },
  acceptInvite(inviteId) {
    return Axios.patch(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/invites/${inviteId}/accept`)
  },
  refuseInvite(inviteId) {
    return Axios.patch(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/invites/${inviteId}/refuse`)
  },
  deleteInvite(inviteId) {
    return Axios.delete(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/invites/${inviteId}`)
  },
  getInviteDetails(filter) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/invites/${filter.inviteId}/details?pageNumber=${filter.pageNumber}&pageSize${filter.pageSize}`)
  }
}

export default invite
